import styled from 'styled-components'

export const ButtonWrapper = styled.button`
  cursor: pointer;
  width: fit-content;
  height: fit-content;
  font-weight: 400;
  font-size: 16px;
  padding: 5px 15px;
  border-radius: 7px;
  transition: 0.3s;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 7px;
  /*-------------------------------
    Events Properties
  -------------------------------*/
  &:focus {
    outline: none;
  }
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background: transparent;
    border: 1px solid ${({ theme }) => `${theme.colors.brand}40`};
    & svg > path {
      stroke: ${({ theme }) => theme.colors.brand};
      ${({ theme, variant }) => variant === 'outlined' && `stroke: ${theme.colors.primary} ;`}
      ${({ theme, color }) => color === 'default' && `stroke: ${theme.colors.background} ;`}
      ${({ theme, color }) => color === 'primary' && `stroke: ${theme.colors.brand} ;`}
      ${({ theme, color }) => color === 'secondary' && `stroke: ${theme.colors.red} ;`}
      ${({ theme, color }) => color === 'secondary-default' && `stroke: ${theme.colors.background} ;`}
      ${({ theme, color }) => color === 'tertiary' && `stroke: ${theme.colors.background} ;`}
    }
    & svg > line {
      stroke: ${({ theme }) => theme.colors.brand};
      ${({ theme, variant }) => variant === 'outlined' && `stroke: ${theme.colors.primary} ;`}
      ${({ theme, color }) => color === 'default' && `stroke: ${theme.colors.background} ;`}
      ${({ theme, color }) => color === 'primary' && `stroke: ${theme.colors.brand} ;`}
      ${({ theme, color }) => color === 'secondary' && `stroke: ${theme.colors.red} ;`}
      ${({ theme, color }) => color === 'secondary-default' && `stroke: ${theme.colors.background} ;`}
      ${({ theme, color }) => color === 'tertiary' && `stroke: ${theme.colors.background} ;`}
    }
    outline: none;

    ${({ theme, variant }) => variant === 'outlined' && `border: 1px solid ${theme.colors.brand}40;`}
    ${({ theme, variant }) => variant === 'outlined' && `background: ${theme.colors.background};`}
    ${({ theme, variant }) => variant === 'outlined' && `color: ${theme.colors.primary};`}

    ${({ theme, variant }) => variant === 'transparent' && `border: 1px solid ${theme.colors.brand}40;`}
    ${({ theme, variant }) => variant === 'transparent' && `background: ${theme.colors.background}00;`}
    ${({ theme, variant }) => variant === 'transparent' && `color: ${theme.colors.primary};`}
    
    ${({ theme, color }) => color === 'default' && `background: ${theme.colors.brand}00;`}
    ${({ theme, color }) => color === 'default' && `color: ${theme.colors.primary};`}
    ${({ theme, color }) => color === 'default' && `border: 1px solid ${theme.colors.brand}40;`}
    
    ${({ theme, color }) => color === 'primary' && `background: ${theme.colors.background};`}
    ${({ theme, color }) => color === 'primary' && `border: 1px solid ${theme.colors.background};`}
    
    ${({ theme, color }) => color === 'secondary' && `background: ${theme.colors.background};`}
    ${({ theme, color }) => color === 'secondary' && `color: ${theme.colors.red};`}
    ${({ theme, color }) => color === 'secondary' && `border: 1px solid ${theme.colors.red};`}
    
    ${({ theme, color }) => color === 'secondary-default' && `background: ${theme.colors.red};`}
    ${({ theme, color }) => color === 'secondary-default' && `color: ${theme.colors.background};`}
    ${({ theme, color }) => color === 'secondary-default' && `border: 1px solid ${theme.colors.red};`}
    
    ${({ theme, color }) => color === 'tertiary' && `background: ${theme.colors.brand};`}
    ${({ theme, color }) => color === 'tertiary' && `color: ${theme.colors.background};`}
    ${({ theme, color }) => color === 'tertiary' && `border: 1px solid ${theme.colors.brand};`}
  }
  &:disabled {
    color: ${({ theme }) => theme.colors.primary} !important;
    background-color: ${({ theme }) => theme.colors.backgroundLite} !important;
    border: 1px solid ${({ theme }) => theme.colors.backgroundLite} !important;
    cursor: not-allowed !important;
    &:hover {
      background-color: ${({ theme }) => theme.colors.backgroundLite} !important;
      border: 1px solid ${({ theme }) => theme.colors.backgroundLite} !important;

      & svg > path {
        stroke: ${({ theme }) => theme.colors.primary};
      }
      & svg > line {
        stroke: ${({ theme }) => theme.colors.primary};
      }
    }
  }
  /*-------------------------------
    Themed Properties
  -------------------------------*/
  border: 1px solid ${({ theme }) => theme.colors.brand};
  color: ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => `${theme.colors.brand}40`};
  /* & svg {
    max-height: 20px;
    max-width: 20px;
    ${({ size }) => size === 'tiny' && 'max-height: 8px !important; max-width: 8px !important;'}
    ${({ size }) => size === 'small' && 'max-height: 10px !important; max-width: 10px !important;'} 
    ${({ size }) => size === 'medium' && 'max-height: 15px !important; max-width: 15px !important;'}
  } */
  & svg > path {
    stroke: ${({ theme }) => theme.colors.white};
    ${({ theme, variant }) => variant === 'outlined' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme, variant }) => variant === 'transparent' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme, color }) => color === 'default' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme, color }) => color === 'primary' && `stroke: ${theme.colors.background} ;`}
    ${({ theme, color }) => color === 'secondary' && `stroke: ${theme.colors.background} ;`}
    ${({ theme, color }) => color === 'secondary-default' && `stroke: ${theme.colors.red} ;`}
    ${({ theme, color }) => color === 'tertiary' && `stroke: ${theme.colors.brand} ;`}
  }
  & svg > line {
    stroke: ${({ theme }) => theme.colors.white};
    ${({ theme, variant }) => variant === 'outlined' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme, variant }) => variant === 'transparent' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme, color }) => color === 'default' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme, color }) => color === 'primary' && `stroke: ${theme.colors.background} ;`}
    ${({ theme, color }) => color === 'secondary' && `stroke: ${theme.colors.background} ;`}
    ${({ theme, color }) => color === 'secondary-default' && `stroke: ${theme.colors.red} ;`}
    ${({ theme, color }) => color === 'tertiary' && `stroke: ${theme.colors.brand} ;`}
  }

  /*-------------------------------
    Variant Colors
  -------------------------------*/
  ${({ theme, variant }) => variant === 'outlined' && `border: 1px solid ${theme.colors.borderColor};`}
  ${({ theme, variant }) => variant === 'outlined' && `color: ${theme.colors.primary};`}
  ${({ variant }) => variant === 'outlined' && 'background: transparent;'}

  ${({ variant }) => variant === 'transparent' && 'border: 1px solid #00000000;'}
  ${({ theme, variant }) => variant === 'transparent' && `color: ${theme.colors.primary};`}
  ${({ variant }) => variant === 'transparent' && 'background: transparent;'}

  ${({ theme, color }) => color === 'default' && `background: ${theme.colors.brand}40;`}
  ${({ theme, color }) => color === 'default' && `color: ${theme.colors.primary};`}
  ${({ theme, color }) => color === 'default' && `border: 1px solid ${theme.colors.brand};`}
    
  ${({ theme, color }) => color === 'primary' && `background: ${theme.colors.primary};`}
  ${({ theme, color }) => color === 'primary' && `border: 1px solid ${theme.colors.primary};`}
  ${({ theme, color }) => color === 'primary' && `color: ${theme.colors.background};`}

  ${({ theme, color }) => color === 'secondary' && `background: ${theme.colors.red};`}
  ${({ theme, color }) => color === 'secondary' && `color: ${theme.colors.white};`}
  ${({ theme, color }) => color === 'secondary' && `border: 1px solid ${theme.colors.red};`}

  ${({ theme, color }) => color === 'secondary-default' && `background: ${theme.colors.background};`}
  ${({ theme, color }) => color === 'secondary-default' && `color: ${theme.colors.red};`}
  ${({ theme, color }) => color === 'secondary-default' && `border: 1px solid ${theme.colors.red};`}
    
  ${({ theme, color }) => color === 'tertiary' && `background: ${theme.colors.backgroundLite};`}
  ${({ theme, color }) => color === 'tertiary' && `color: ${theme.colors.primary};`}
  ${({ theme, color }) => color === 'tertiary' && `border: 1px solid ${theme.colors.backgroundLite};`}
  /*-------------------------------
    Variant Sizes
  -------------------------------*/
  ${({ size }) => size === 'tiny' && 'padding: 0 5px !important; border-radius: 3px; font-size: 8px !important;'} 
  ${({ size }) => size === 'small' && 'font-size: 13px !important;'} 
  ${({ size }) => size === 'medium' && 'font-size: 16px !important;'} 

  /*-------------------------------
    Conditional Properties
  -------------------------------*/
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
`
